import { render } from "./PlanosViewThyago.vue?vue&type=template&id=1032dc4e&scoped=true"
import script from "./PlanosViewThyago.vue?vue&type=script&lang=js"
export * from "./PlanosViewThyago.vue?vue&type=script&lang=js"

import "./PlanosViewThyago.vue?vue&type=style&index=0&id=1032dc4e&scoped=true&lang=css"
import "./PlanosViewThyago.vue?vue&type=style&index=1&id=1032dc4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1032dc4e"]])

export default __exports__